import React, { useEffect, useState } from "react";
import PageHeader from "../../components/header/PageHeader";
import CustomBtn from "../../components/btn/CustomBtn";
import { IconPlus } from "@tabler/icons-react";
import AddImages from "./components/AddImages";
import ConfirmModal from "../../components/modal/ConfirmModal";
import api from "../../api";
import { useToast } from "../../components/toast";
import styles from "./styles.module.scss";
import { Empty, Image, Spin } from "antd";

export default function Banner() {
  const [showDrawer, setShowDrawer] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const fetchData = async () => {
    setLoading(true);
    const res = await api.get_banners();
    if (res?.status === 200) {
      setData(res.data.data || []);
    } else {
      toast(res?.data?.message || "Алдаа гарлаа", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteHandler = async () => {
    if (!deleteId) return;

    const res = await api.delete_banner(deleteId);

    if (res.status === 200 || res.status === 204) {
      toast("Баннер амжилттай устлаа", "success");
      setShowModal(false);
      setDeleteId(null);
      fetchData();
    } else {
      toast(res?.data?.message || "Баннер устгахад алдаа гарлаа", "error");
    }
  };

  return (
    <>
      <PageHeader
        title={"Баннер"}
        right={
          <CustomBtn
            title="Зураг нэмэх"
            icon={<IconPlus size={18} />}
            onClick={() => setShowDrawer(true)}
          />
        }
      />

      <Spin spinning={loading}>
        {!loading && data.length === 0 ? (
          <Empty
            description="Баннер алга байна"
            style={{ padding: "60px 0" }}
          />
        ) : (
          <div className={styles.bannerGrid}>
            {data.map((item, i) => {
              const url = item.image_url;

              return (
                <div key={item.id || url || i} className={styles.imgWrapper}>
                  <Image
                    src={url}
                    alt={`banner-${i}`}
                    width="100%"
                    height="100%"
                    imgStyle={{ objectFit: "cover" }}
                    preview={false}
                  />

                  {/* Жижиг delete товч (дээр нь байрлуулах) */}
                  <button
                    type="button"
                    className={styles.deleteBtn}
                    onClick={() => {
                      setDeleteId(item.id);
                      setShowModal(true);
                    }}
                  >
                    Устгах
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </Spin>

      <AddImages
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
        trigger={() => fetchData()}
      />

      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        submitHandler={deleteHandler}
        variant="error"
        title="Итгэлтэй байна уу?"
        description={
          <>
            '
            <span style={{ fontWeight: 600, color: "#000" }}>Зураг устгах</span>
            ' үйлдэл хийснээр хэрэглэгчид харагдахгүй болохыг анхаарна уу!
          </>
        }
      />
    </>
  );
}
